// me.js
'use strict';
import { fromJS } from 'immutable';
import isString from 'lodash/isString';

import objectifyArrayById from '../resource/objectifyArrayById.js';
import {
  MERGE_ME_DATA,
  LOGOUT,
  MERGE_FLIGHT_CHECK_DATA,
  UPDATE_SETTINGS_DATA,
  SET_ME_DATA,
  RESTORE_ME_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
} from '../ActionTypes.js';

const profileListTemplate = {
  id: 'list',
  pathname: '/',
  i18nTitle: 'list',
  isUsing: false,
};

export const defaultState = fromJS({
  notificationAsker: {},
  flightCheck: {
    isUsernameSet: false,
    isBirthdateSet: true,
    isUnderage: false,
    shouldGoTutorials: false,
    isEmailSet: true,
    isEmailAgreed: null,
  },
  profileLists: objectifyArrayById({
    array: [
      {
        id: 'story',
        pathname: '/unlocked-users',
        i18nTitle: 'archives_title_short',
        isUsing: true,
      },
      {
        id: 'flix',
        pathname: '/unlocked-users',
        i18nTitle: 'archives_title_short',
      },
    ],
    template: profileListTemplate,
  }),
  usingList: [],
  downloadMobileApp: {},
  accountLinks: {
    email: null,
    google: null,
    facebook: null,
    twitter: null,
    phoneNumber: null,
  },
  utm: {},
  regionGroup: null,
  billingProfile: {
    email: '',
    ezpay: {
      address: null,
      carrier_type: null,
      include_email: null,
      name: null,
      phone_number: null,
    },
  },
  ab: {},
  balance: {
    total: null,
  },
  country: '',
  defaultCountryCode: 'TW',
  paymentMethods: {},
  redirect: {},
  hasScrollHintDisplayed: false,
});

/**
 * Personal data including authing, preference, balance, etc.
 * @module reducer/me
 */
const me = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_ME_DATA:
      return _MERGE_ME_DATA(action.payload)(state);
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    case MERGE_FLIGHT_CHECK_DATA:
      return _MERGE_FLIGHT_CHECK_DATA(action.payload)(state);
    case UPDATE_SETTINGS_DATA:
      return _UPDATE_SETTINGS_DATA(action.payload)(state);
    case SET_ME_DATA:
      return _SET_ME_DATA(action.payload)(state);
    case RESTORE_ME_DATA:
      return _RESTORE_ME_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    default:
      return state;
  }
};

/**
 * Merge me data
 * @kind reducer/actionType
 * @name MERGE_ME_DATA
 * @param {object} meData - meData
 * @return {Immutable.Map} New state
 */
const _MERGE_ME_DATA = meData => state => {
  return state.mergeDeep(meData);
};

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => state => {
  return defaultState.mergeDeep({
    // downloadMobileApp: state.get('downloadMobileApp'),
    clientId: state.get('clientId'),
    defaultUsername: state.get('defaultUsername'),
    utm: state.get('utm'),
    regionGroup: state.get('regionGroup'),
    country: state.get('country'),
    ab: {
      loading: state.getIn(['ab', 'loading']),
    },
  });
};

/**
 * Merge flight check data
 * @kind reducer/actionType
 * @name MERGE_FLIGHT_CHECK_DATA
 * @param {object} flightCheck - flight check data.
 * @return {Immutable.Map} New state
 */
const _MERGE_FLIGHT_CHECK_DATA = flightCheck => state => {
  return state.mergeIn(['flightCheck'], flightCheck);
};

/**
 * Update settings data
 * @kind reducer/actionType
 * @name UPDATE_SETTINGS_DATA
 * @param {array} {selectPath} - select path in settings
 * @param {any} {value} - value
 * @return {Immutable.Map} New state
 */
const _UPDATE_SETTINGS_DATA =
  ({ selectPath, value }) =>
  state => {
    return state.setIn(['settings', ...selectPath], fromJS(value));
  };

/**
 * Set me data
 * @kind reducer/actionType
 * @name SET_ME_DATA
 * @param {object} payload - payload
 * @param {string|array} payload.selectPath - select path
 * @param {any} payload.value - value
 * @return {Immutable.Map} New state
 */
const _SET_ME_DATA =
  ({ selectPath, value }) =>
  state => {
    if (isString(selectPath)) {
      return state.set(selectPath, fromJS(value));
    }
    return state.setIn(selectPath, fromJS(value));
  };

/**
 * Restore me data
 * @kind reducer/actionType
 * @name RESTORE_ME_DATA
 * @param {object} meData - me data.
 * @return {Immutable.Map} New state
 */
const _RESTORE_ME_DATA = meData => state => {
  return state.mergeDeep(meData);
};

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

export default me;
